module.exports = __webpack_public_path__ + "static/img/cancel-red.b1e54a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/cancel-red.png
// module id = ORka
// module chunks = 1